module.exports = __webpack_public_path__ + "img/Legends-Hoodie-02@2x.0c2f302d.jpg";